// extracted by mini-css-extract-plugin
var _1 = "FilePreviewOverlay-moduleFilePreviewOverlay__vJvIV";
var _2 = "FilePreviewOverlay-moduledeleteButton__RxBY4";
var _3 = "FilePreviewOverlay-moduledisabled__g1Vy3";
var _4 = "FilePreviewOverlay-moduleemptySelectedIcon__GQyuP";
var _5 = "FilePreviewOverlay-moduleerror__uhPEm";
var _6 = "FilePreviewOverlay-moduleicon__E45rA";
var _7 = "FilePreviewOverlay-moduleselectIcon__WwvhF FilePreviewOverlay-moduleicon__E45rA";
var _8 = "FilePreviewOverlay-moduleselected__S9JuB";
var _9 = "FilePreviewOverlay-moduleselectedIcon__VCzGh IconNG-moduleIcon__AbXiV";
export { _1 as "FilePreviewOverlay", _2 as "deleteButton", _3 as "disabled", _4 as "emptySelectedIcon", _5 as "error", _6 as "icon", _7 as "selectIcon", _8 as "selected", _9 as "selectedIcon" }
